export default "__VITE_ASSET__BNysZSI9__"